import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi2";
import { StepLog } from "../../types/post";
import {
  useLogCardActions,
  LogCardActionsProps,
} from "../../hooks/useLogCardActions";
import LogCard from "../shared/LogCard";
import { LogCardNote } from "../shared/LogCardContent";

interface StepLogCardProps
  extends LogCardActionsProps<StepLog & { id: string }> {
  log: StepLog & { id: string };
}

const StepLogCard: React.FC<StepLogCardProps> = ({ log, onDelete, onEdit }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { handleDelete, handleEdit } = useLogCardActions(log, {
    onDelete,
    onEdit,
  });

  const handleCardClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div onClick={handleCardClick} className="cursor-pointer">
      <LogCard
        className={isExpanded ? "bg-base-100" : "bg-base-200/70"}
        onDelete={onDelete ? handleDelete : undefined}
        onEdit={onEdit ? handleEdit : undefined}
      >
        {/* Header */}
        <div className="flex items-center gap-2 pr-8">
          <span className="text-[11px] font-medium tracking-wide uppercase text-base-content/70 font-geist">
            Steps
          </span>
          <span className="text-xs font-bold text-base-content font-geist">
            {log.steps.toLocaleString()}
          </span>
          {log.notes && (
            <HiChevronDown
              className={`w-3 h-3 text-base-content/30 transition-transform duration-200 ml-auto ${
                isExpanded ? "rotate-180" : ""
              }`}
            />
          )}
        </div>

        {/* Notes only shown when expanded */}
        {isExpanded && log.notes && (
          <div className="mt-2">
            <LogCardNote text={log.notes} />
          </div>
        )}
      </LogCard>
    </div>
  );
};

export default StepLogCard;
